module.exports = __webpack_public_path__ + "img/we-accept_text.7dcddd41.png";